<template>
    <div>
        <DataLoader :is_on="creating_report" />
        <div id="table" class="report-table">
            <div class="rocisnik-top">
                <div class="rokovnik-title"> {{ this.razdoblje == '' ? 'Rokovnik za razdoblje ' + getToday() + ' ~ ' :
                        'Rokovnik za razdoblje ' + this.razdoblje
                }}</div>
                <div class="print-wrapper" @click="print()">
                    <span>Preuzmi izvještaj</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="36" viewBox="0 0 30 36" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.5574 0C11.0601 0 9.81104 1.21625 9.68029 2.8016C9.40692 6.11624 9.33774 9.44566 9.47296 12.7686C9.30973 12.7802 9.14654 12.7923 8.98336 12.8049L6.10045 13.0283C4.25777 13.1711 3.2277 15.3548 4.22251 17.0096C6.34414 20.5386 9.07791 23.6066 12.2781 26.05L13.4331 26.9318C14.3695 27.6468 15.6308 27.6468 16.5672 26.9318L17.7222 26.05C20.9224 23.6066 23.6562 20.5386 25.7778 17.0096C26.7726 15.3548 25.7425 13.1711 23.8999 13.0283L21.017 12.8049C20.8538 12.7923 20.6906 12.7802 20.5273 12.7686C20.6626 9.44565 20.5934 6.11623 20.32 2.80158C20.1893 1.21624 18.9402 0 17.4429 0H12.5574ZM12.4482 14.1217C12.2281 10.4452 12.2692 6.75601 12.5712 3.08571H17.4291C17.7311 6.75601 17.7722 10.4452 17.5521 14.1217C17.5274 14.5339 17.6593 14.9394 17.9181 15.2474C18.177 15.5555 18.5412 15.7404 18.9294 15.7607C19.5552 15.7934 20.1807 15.834 20.8059 15.8825L22.8996 16.0447C21.0424 18.9521 18.717 21.4911 16.0284 23.5438L15.0002 24.3289L13.9719 23.5438C11.2833 21.4911 8.95788 18.9521 7.10071 16.0447L9.19443 15.8825C9.81957 15.834 10.4451 15.7934 11.0709 15.7607C11.4591 15.7404 11.8233 15.5555 12.0822 15.2474C12.341 14.9394 12.4729 14.5339 12.4482 14.1217Z"
                            fill="#606076" />
                        <path
                            d="M2.90323 28.2857C2.90323 27.4336 2.25332 26.7429 1.45161 26.7429C0.649909 26.7429 0 27.4336 0 28.2857V32.4C0 34.3882 1.51646 36 3.3871 36H26.6129C28.4835 36 30 34.3882 30 32.4V28.2857C30 27.4336 29.3501 26.7429 28.5484 26.7429C27.7467 26.7429 27.0968 27.4336 27.0968 28.2857V32.4C27.0968 32.684 26.8801 32.9143 26.6129 32.9143H3.3871C3.11986 32.9143 2.90323 32.684 2.90323 32.4V28.2857Z"
                            fill="#606076" />
                    </svg>
                </div>
            </div>
            <a @click="goBack()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
            <div id="wrapp-roc-pdf">


                <div class="report-row report-main-header">
                    <div class="column column1">
                        Početak
                    </div>
                    <div class="column column2">
                        Zaduženje
                    </div>
                    <div class="column column3">
                        Predmet
                    </div>
                    <div class="column column4">
                        Naziv aktivnosti
                    </div>
                    <div class="column column5">
                        Sudski broj
                    </div>
                    <div class="column column6">
                        Nadležnost i sudionici
                    </div>
                </div>
                <div v-for="(day, key) in grouped_rocista" :key="key" class="report-section">
                    <div class="report-row report-date-row">{{ getDate(day[0]) }} ({{ getDayName(day[0]) }})</div>
                    <div v-for="(event, key) in day[1]" :key="key" class="report-row report-rociste">
                        <div class="column column1">
                            {{ getSatiEvent(event.start_date_time) }}
                        </div>
                        <div class="column column2 multiple-values">
                            <div v-for="(zaduzenik, key) in event.event_lawyer_connector" :key="key"
                                class="sudionici-osoba">
                                {{ zaduzenik.odvjetnik.ime }} {{ zaduzenik.odvjetnik.prezime }}
                            </div>
                        </div>
                        <div class="column column3">
                            {{ event.spis.predmet.ime_predmeta }}
                        </div>
                        <div class="column column4">
                            {{ event.title }}
                        </div>
                        <div class="column column5">
                            {{ event.spis.posl_br }}
                        </div>
                        <div class="column column6 multiple-values">
                            <div v-if="event.spis.institucija != undefined && event.spis.institucija != null" class="sudionici-osoba"> <b>{{ event.spis.institucija.naziv }}</b>
                            </div>
                            <div v-for="(partic, key) in event.spis.spis_sudionici_connector" :key="key"
                                class="sudionici-osoba"> <b>{{ partic.sluzbena_osoba.ime }}
                                    {{ partic.sluzbena_osoba.prezime }}</b> {{ partic.sluzbena_uloga.uloga_name !=
                                            undefined && partic.sluzbena_uloga.uloga_name != null ?
                                            '(' + partic.sluzbena_uloga.uloga_name + ')' : ''
                                    }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from "moment";
import $ from 'jquery';
import gsap from 'gsap';
import ms_calendar from "@/apiCallers/calendarSharepoint";
import DataLoader from '@/components/generalComponents/DataLoader';

export default {
    components:{
        DataLoader,
    },
    data() {
        return {
            rocista: [],
            grouped_rocista: [],
            razdoblje: '',
            creating_report: false,
        }
    },
    methods: {
        async print() {
            this.creating_report = true;
            let temp_str = $("#table").clone()
            $(temp_str).find(".print-wrapper,.entry-exit").remove()
            let html_to_print = $(temp_str)[0].outerHTML
            await ms_calendar.printCalendar(html_to_print).then(async(resp) => {
                var newBlob = new Blob([resp.data], {
                  type: "application/pdf",
                });
                var data = window.URL.createObjectURL(newBlob);

                var link = document.createElement("a");
                link.href = data;
                link.download ="ročišnik-" + moment().format("l") + ".pdf";
                link.click();
                setTimeout(function () {
                  // For Firefox it is necessary to delay revoking the ObjectURL
                  window.URL.revokeObjectURL(data);
                }, 100);
                this.creating_report = false;
            }).catch((_err)=>{
                this.creating_report = false;
            })
            //html_to_print sadrzi html izvjestaj spreman za print
            //poslati html_to_print na back endpoint
        },
        //returns twodimensional array groupped by date
        //[0] group date
        //[1] list of events
        groupByDate(events) {
            let grouped = events.reduce((group, event) => {
                const category = event.start_date_time.split('T')[0];
                if (!group[category]) {
                    group[category] = [];
                }
                group[category].push(event);
                return group;
            }, []);
            return Object.keys(grouped).map((key) => [(key), grouped[key]])
        },
        getDate(date) {
            return moment(date).format("DD.MM.yyyy.");
        },
        getToday() {
            return moment().format("DD.MM.yyyy.");
        },
        getDayName(date) {
            return moment(date).format("dddd");
        },
        getSatiEvent(fullDateTime) {
            return moment(fullDateTime).format("LT");
        },
        goBack() {
            this.$router.go(-1);
        },
    },
    mounted() {
        document.body.classList.add("new-entry");
        if (this.$store.state.rocista_report_data.events == null) {
            this.$router.go(-1);
        }
        this.rocista = this.$store.state.rocista_report_data.events;
        this.razdoblje = this.$store.state.rocista_report_data.razdoblje;
        console.log(this.rocista);
        console.log(this.razdoblje);
        // console.log(this.$route.query.rocista);
        // this.rocista = this.$route.query.rocista;
        this.grouped_rocista = this.groupByDate(this.rocista);
        // var table = $('#table');
        // console.log(table);
        console.log(this.grouped_rocista);
        $(".entry-exit").hover(
            function () {
                gsap.to($(this).find("img"), 0.3, {
                    rotation: 180,
                    transformOrigin: "center",
                });
            },
            function () {
                gsap.to($(this).find("img"), 0.5, {
                    rotation: -180,
                    transformOrigin: "center",
                });
            }
        );
    },
    destroyed() {
        document.body.classList.remove("new-entry");
        $(".entry-exit").off();
    },
}
</script>